import { createAction, props } from '@ngrx/store';
import { ModuleConfig, ModuleId } from '@intellio/shared/models';

export enum ModuleConfigsActionTypes {
  GetModuleConfigs = '[Module Configs] Get',
  GetModuleConfigsSuccess = '[Module Configs] Get Success',
  GetModuleConfigsFailure = '[Module Configs] Get Failure',
}

export const getModuleConfigs = createAction(
  ModuleConfigsActionTypes.GetModuleConfigs,
  props<{ moduleId: ModuleId }>()
);

export const getModuleConfigsSuccess = createAction(
  ModuleConfigsActionTypes.GetModuleConfigsSuccess,
  props<{ moduleId: ModuleId; configs: ModuleConfig[] }>()
);

export const getModuleConfigsFailure = createAction(
  ModuleConfigsActionTypes.GetModuleConfigsFailure,
  props<{ moduleId: ModuleId; error: any }>()
);
